'use client';

import { useContext } from 'react';

import { useFlags } from 'launchdarkly-react-client-sdk';

import { FeatureFlagsContext } from './context';
import { FeatureFlag, localFeatureFlagValues } from '../../constants';

export function useFeatureFlags(): {
  allowedEditingFeatureFlags: boolean;
  featureFlags: typeof localFeatureFlagValues;
  featureFlagsToOverride: Partial<typeof localFeatureFlagValues>;
  isInitialized: boolean;
  resetFeatureFlagLocally: (key: FeatureFlag) => void;
  setFeatureFlagLocally: (key: FeatureFlag, value: any) => void;
} {
  const contextFlags = useContext(FeatureFlagsContext);

  try {
    const featureFlags = useFlags() as typeof localFeatureFlagValues;

    return {
      allowedEditingFeatureFlags: contextFlags.allowedEditingFeatureFlags,
      featureFlags: {
        ...localFeatureFlagValues,
        ...(Object.keys(featureFlags).length > 0 ? featureFlags : localFeatureFlagValues),
        ...contextFlags.featureFlagsToOverride,
      },
      featureFlagsToOverride: contextFlags.featureFlagsToOverride,
      isInitialized: contextFlags.isInitialized,
      resetFeatureFlagLocally: contextFlags.resetFeatureFlagLocally,
      setFeatureFlagLocally: contextFlags.setFeatureFlagLocally,
    };
  } catch {
    // eslint-disable-next-line no-console
    console.error('Error fetching feature flags');

    return {
      allowedEditingFeatureFlags: contextFlags.allowedEditingFeatureFlags,
      featureFlags: {
        ...localFeatureFlagValues,
        ...contextFlags.featureFlagsToOverride,
      },
      featureFlagsToOverride: contextFlags.featureFlagsToOverride,
      isInitialized: contextFlags.isInitialized,
      resetFeatureFlagLocally: contextFlags.resetFeatureFlagLocally,
      setFeatureFlagLocally: contextFlags.setFeatureFlagLocally,
    };
  }
}
